import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import RemoveIcon from '@mui/icons-material/Remove';
import EditIcon from '@mui/icons-material/Edit';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles';
import { usePermissions } from "@/hooks/usePermissions";
import SearchInput from '@/components/SearchInput'
import {
  openRemoveDebtModal,
  openBulkWriteOffModal,
  setEditDebtModalParams,
} from '@/features/billing/billingSlice';
import { selectActiveBuildingId } from '@/features/building/buildingSlice';

const TableTopBar = ({ 
  onSearchChange,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const activeBuildingId = useSelector(selectActiveBuildingId);
  const { hasPermission } = usePermissions()
  const { t } = useTranslation()
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const onRemoveDebtHandler = () => {
    dispatch(openRemoveDebtModal())
  }
  const onBulkWriteOffHandler = () => {
    dispatch(openBulkWriteOffModal())
  }
  const onEditDebtHandler = () => {
    dispatch(setEditDebtModalParams({
      buildingId: activeBuildingId,
    }));
  }

  return (
    <Stack
      direction={'row'}
      spacing={1}
      sx={{
        alignItems: 'center',
        flex: 1,
        minWidth: 0,
        mb: 2
      }}>
      <SearchInput
        placeholder={t('enter_number')}
        onChange={onSearchChange}
        delay={300}
      />
      <Divider orientation="vertical" flexItem />
      {
        hasPermission('billing.writeOff') && (
          <Stack 
            direction="row" 
            spacing={1}
          >
            {
              isSmallScreen ? (
                <IconButton
                  color="primary"
                  size="small"
                  onClick={onRemoveDebtHandler}
                >
                  <RemoveIcon />
                </IconButton>
              ) : (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<RemoveIcon />}
                  onClick={onRemoveDebtHandler}
                >
                  {
                    isMediumScreen 
                      ? t('billing_write_off') 
                      : t('billing_write_off_by_plate')
                  }
                </Button>
              )
            }
            {
              isSmallScreen ? (
                <IconButton
                  color="primary"
                  size="small"
                  onClick={onEditDebtHandler}
                >
                  <EditIcon />
                </IconButton>
              ) : (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<EditIcon />}
                  onClick={onEditDebtHandler}
                >
                  { 
                    t('billing_edit_debt') 
                  }
                </Button>
              )
            }
          </Stack>
        )
      }
      {
        hasPermission('billing.bulkWriteOff') && (
          isSmallScreen ? (
            <IconButton
              color="warning"
              size="small"
              onClick={onBulkWriteOffHandler}
            >
              <MoneyOffIcon />
            </IconButton>
          ) : (
            <Button
              variant="outlined"
              color="warning"
              size="small"
              startIcon={<MoneyOffIcon />}
              onClick={onBulkWriteOffHandler}
            >
              {t('billing_bulk_write_off')}
            </Button>
          )
        )
      }
    </Stack>
  );
}
export default TableTopBar
